import { apiPost } from "../client";
import { useMutation } from "@tanstack/react-query";

/**
 * 특정 사용자의 토큰을 생성합니다.
 * @param userId - 토큰을 생성할 사용자의 ID
 */

interface IGenerateTokenResponse {
  token: string;
}

export const apiGenerateToken = async (userId: string) => {
  return await apiPost<IGenerateTokenResponse>(`/users/${userId}/token`);
};
